/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyWon = createReactComponent("outline", "currency-won", "IconCurrencyWon", [["path", { "d": "M4 6l3.245 11.358a.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a.85 .85 0 0 0 1.624 -.035l3.245 -11.358", "key": "svg-0" }], ["path", { "d": "M21 10h-18", "key": "svg-1" }], ["path", { "d": "M21 14h-18", "key": "svg-2" }]]);

export { IconCurrencyWon as default };
//# sourceMappingURL=IconCurrencyWon.mjs.map
